// extracted by mini-css-extract-plugin
module.exports = {"element":"_7a3fb80146--element--hhgQA"};